import { applyService } from '@/service/index'
import { EventDispatcher } from "@/service/EventDispatcher"

const STIPULATION_COMPLETED_EVENT = 'completed'

const defaultConfig = {
    checkIntervalMillis: 5000
}

export default class StipulationListener {

    #eventDispatcher = new EventDispatcher()
    #providerKey = null
    #stipulationId = null
    #checkInterval = null
    #checkIntervalMillis = null

    constructor (providerKey, stipulationId, config) {
        this.#providerKey = providerKey
        this.#stipulationId = stipulationId

        config = Object.assign({}, defaultConfig, config)

        this.#checkIntervalMillis = config.checkIntervalMillis
    }

    onStipulationCompleted (handler) {
        this.#eventDispatcher.addEventListener(STIPULATION_COMPLETED_EVENT, handler)
    }

    init () {
        this._startPolling()
        this._checkStipulationStatus()
    }

    destroy () {
        this._stopPolling()
    }

    _startPolling () {
        this.#checkInterval = setInterval(() => {
            this._checkStipulationStatus()
        }, this.#checkIntervalMillis)
    }

    _stopPolling () {
        if (this.#checkInterval) {
            clearInterval(this.#checkInterval)
        }
    }

    async _checkStipulationStatus () {
        let {status} = await applyService.getStipulationStatus(this.#providerKey, this.#stipulationId)

        if (status === 'completed') {
            this.#eventDispatcher.dispatchEvent(new CustomEvent(STIPULATION_COMPLETED_EVENT, {status}))
            this._stopPolling()
        }
    }

}
